import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../commanPage/pagination/Pagination";
const initailBitData = [
  {
    id: 1,
    auction_id: "DAC56565",
    company: "Infinite cercle Private limited",
    date: "04/04/2024",
    status: "Live",
  },
  {
    id: 2,
    auction_id: "DAC56565",
    company: "Infinite cercle Private limited",
    date: "04/04/2024",
    status: "Completed",
  },
  {
    id: 3,
    auction_id: "DAC56565",
    company: "Infinite cercle Private limited",
    date: "04/04/2024",
    status: "Live",
  },
  {
    id: 4,
    auction_id: "DAC56565",
    company: "Infinite cercle Private limited",
    date: "04/04/2024",
    status: "Live",
  },
  {
    id: 5,
    auction_id: "DAC56565",
    company: "Infinite cercle Private limited",
    date: "04/04/2024",
    status: "Completed",
  },
];

function BitHistoryTable() {
  const totalNumberRow = 6;
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [bitHistory, setBitHistory] = useState([...initailBitData]);
  return (
    <>
      <div className="table-container-style mt-1">
        <table
          className={`responsive-table centered ${
            isTablet ? "auction_table table-style" : "custom-table-style"
          } `}
        >
          <thead>
            <tr>
              <th>S.No</th>
              <th>Auction ID</th>
              <th>Seller ID</th>
              <th>Date</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="white">
            {bitHistory?.map((items, index) => (
              <tr key={items.id}>
                <td>{items.id}</td>
                <td>{items.auction_id}</td>
                <td>{items.company}</td>
                <td>{items.date}</td>
                <td>{items.status}</td>
                <td>
                  <img
                    className="pointer"
                    src="/icons/visibility.svg"
                    alt="visibility"
                    onClick={() => navigate("/bit/details")}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination
        Data={bitHistory}
        totalNumberRow={totalNumberRow}
        setCurrentPage={setCurrentPage}
      />
    </>
  );
}

export default BitHistoryTable;
